import React from 'react';

const SvgZa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="ZA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ZA_svg__b" fill="#fff">
        <use xlinkHref="#ZA_svg__a" />
      </mask>
      <use fill="#06A86E" xlinkHref="#ZA_svg__a" />
      <path
        fill="#FFBF2E"
        mask="url(#ZA_svg__b)"
        d="M0 2.667L9.333 10 0 17.333z"
      />
      <path fill="#262626" mask="url(#ZA_svg__b)" d="M-1.333 3l9 7-9 7z" />
      <path fill="#FFF" mask="url(#ZA_svg__b)" d="M12 8L2.667 0H28v8z" />
      <path
        fill="#F44E46"
        mask="url(#ZA_svg__b)"
        d="M12.333 6.667L4.333 0H28v6.667z"
      />
      <path fill="#FFF" mask="url(#ZA_svg__b)" d="M2.667 20H28v-8H12z" />
      <path
        fill="#072CB4"
        mask="url(#ZA_svg__b)"
        d="M4.333 20H28v-6.667H12.333z"
      />
    </g>
  </svg>
);

export default SvgZa;
